<template>
    <div class="footCom">
      <div class="top" @click="gotoTop">
        <img  src="../assets/top.png" alt="">
      </div>
    <div class="one">
    <div class="oneItem">
    <p>{{$t('foot.con[0].title')}}</p>
      <p style="font-family: light2">{{$t('foot.con[0].content')}}</p>
    </div>
      <div class="oneItem">
        <p>{{$t('foot.con[1].title')}}</p>
        <p style="font-family: light2">{{$t('foot.con[1].content')}}</p>
       <div class="fiveImg">
         <i class="iconfont icon-guge"></i>
         <i class="iconfont icon-tuite"></i>
         <i class="iconfont icon-facebook-copy"></i>
         <i class="iconfont icon-lingying"></i>
         <i class="iconfont icon-INS-"></i>
       </div>
      </div>
      <div class="oneItem">
        <p>{{$t('foot.con[2].title')}}</p>
        <p style="font-family: light2">{{$t('foot.con[2].content')}}</p>
        <p style="font-weight: bold">{{$t('foot.con[2].content2')}}<br>
          {{$t('foot.con[2].content3')}}<br>
          {{$t('foot.con[2].content4')}}
        </p>

      </div>
    </div>
      <div class="two">
      <span>{{$t('foot.title')}}</span>
        <ul>
          <li v-for="(item,index) in $t('navList')" :key="index"><span @click="goto(index)">{{item}}</span><span class="line"></span></li>
        </ul>
      </div>
      <div class="three">
      <span style="font-family: light2">{{$t('foot.title1')}}</span>
        <span style="font-family: light2"><a href="https://www.sansg.com/"> {{$t('foot.title2')}}</a></span>
      </div>
    </div>
</template>

<script>
  import Scrollbar from 'smooth-scrollbar';
  import qs from 'qs'
    export default {
        name: "foot",
      data(){
          return{
            navList:[
              "Home",
              "Product",
              "About Us",
              "News",
              "Support",
              "Feedback"
            ],
            aStyle:{
              backgroundColor:'red'
            },
            imgList:[
              require("../assets/google.png"),
              require("../assets/tt.png"),
              require("../assets/web-Facebook.png"),
              require("../assets/ly.png"),
              require("../assets/ins.png"),
            ]
          }
      },
      methods:{
        gotoTop(){
          this.$emit('gotoTop')
        },
          goto(index){
            if(index===0){
              this.$router.push({path:'/'})
            }else if(index===1){
              this.$router.push({path:'/product'})
            }else if(index===2){
              this.$router.push({path:'/about'})
            }else if(index===3){
              this.$router.push({path:'/news'})
            }else if(index===4){
              this.$router.push({path:'/contact'})
            }else {
              this.$router.push({path:'/feed'})
            }
          }
      }
    }
</script>

<style scoped>
.footCom{
  width:100%;
  padding-top: 60px;
  padding-bottom: 10px;
  background-color: #FAFAFA;
  position: relative;
}
  .one{
    width:1280px;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    padding-bottom: 30px;
    justify-content: space-between;
  }
  p{
    text-align: left;
    line-height: 25px;
    transition: all 2s;
  }
  p:hover{
    color:#C9382C;
  }
  .oneItem{
    border-right: 1px solid rgba(0,0,0,0.2);
    padding-right: 2%;
    margin-left: 5%;
  }
  .oneItem p:first-child{
    font-weight: bold;
    font-size: 20px;
  }
  .oneItem ul{
    width:100%;
    list-style: none;
    padding-inline-start: 0px;
  }
  .oneItem ul li{
    float: left;
    height:39px;
    width:39px;
   border-radius: 50%;
    border: 1px solid rgba(0,0,0,0.2) ;
    margin-left: 5%;
  }
  .oneItem ul li:first-child{
    margin-left: 0;
  }
  .oneItem ul li img{
    margin: 11px auto;
  }
  .two{
    width:1280px;
    margin: 0 auto;
    height:80px;
    border-bottom: 1px solid rgba(0,0,0,0.2);
    display: flex;
    flex-direction: row;
  }
  .two span{
    font-weight: bold;
    font-size: 20px;
    margin-left: 5%;
    transition: all 2s;
  }
  .two span:hover{
    color:#C9382C;
  }
.two ul{
  list-style: none;
  padding-inline-start: 0;
  width:100%;
}
.two ul li{
  float: left;
  font-weight: bold;
  cursor: pointer;
  position: relative;
  width:10%;
  height:65px;
  margin-left: 6%;
}
.two ul li span{
  font-size: 16px;
  color:#686868;
  transition:color 2s;
  -webkit-transition:color 2s ;
  line-height: 20px;
}
.line{
  position: absolute;
  bottom: 0;
  width:0;
  height:2px;
  background-color:#C9382C;
  left: 50%;
  display: none;
  animation: myMove .5s linear forwards;
  transform: translate(-50%);
}
@keyframes myMove {
  from {width:0;}
  to {width:100%;}
}
@-webkit-keyframes mymove /*Safari 和 Chrome*/{
  from {width:0;}
  to {width:100%;}
}
.two ul li:hover .line,.two ul li:hover span{
  display: block;
  color:#C9382C;
}
  .three{
    width:1280px;
    margin: 20px auto;
    display: flex;
    flex-direction: row;
  }
  .three span:first-child{
    margin-left: 5%;
  }
  .three span:last-child{
    margin-left: 40%;
  }
  a{
    text-decoration: none;
    color:black;
    transition: all 2s;
  }
  a:hover{
    color:#C9382C;
  }
  .three span{
    transition: all 2s;
  }
  .three span:hover{
    color:#C9382C;
  }
  .top{
    position: absolute;
    top:-20px;
    left: 80%;
    height:80px;
    width:80px;
    border-radius: 50%;
    background-color: white;
    cursor: pointer;
    transition: all 2s;
  }
  .top:hover{
    box-shadow: 0 0 10px #f00;
  }
  .top img{
    margin: 10px auto;
  }
  .fiveImg{
    width:100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .fiveImg i{
    height:50px;
    width:50px;
    border-radius: 50px;
    border: 1px solid #DBDBDB;
    display: inline-block;
    line-height: 50px;
    font-size: 20px;
    color:#686868;
    cursor: pointer;
    transition: all 2s;

  }
.fiveImg i:hover{
  background-color: #C9382C;
  color:white;
}
@media screen and (max-width:450px){
  .oneItem{
    border-right: none;
  }
  .one{
    width:100%;
    display: flex;
    flex-direction: column;
  }
  .two{
    display: none;
  }
  .three{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue